import React, { useMemo, useState } from 'react';

// Reusable crypto token icon with multi-source fallback
// Order: local public /SYMBOL.svg -> spothq cryptocurrency-icons -> cryptoicons.org -> text fallback
const TokenIcon = ({ symbol, size = 24, className = '', style = {} }) => {
  const normalized = (symbol || '').toString().trim().toUpperCase();
  const lower = normalized.toLowerCase();

  // Local known overrides that live in public/
  const localOverrides = new Set(['BTC', 'ETH', 'VEBE', 'VEEE', 'DOGE']);

  const sources = useMemo(() => {
    const list = [];
    // Special-case: prefer local PNG for specific tokens
    if (normalized === 'SOL') {
      list.push(`/SOL.png`);
    }
    if (normalized === 'BTC') {
      list.push(`/BTC.png`);
    }
    if (normalized === 'DOGE') {
      list.push(`/DOGE.png`);
    }
    // 1) Local public asset (SVG)
    list.push(`/${normalized}.svg`);
    // 2) spothq cryptocurrency-icons (SVG color)
    list.push(`https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/${lower}.svg`);
    // 3) cryptoicons.org PNG API (specify size close to desired)
    const pngSize = Math.max(64, Math.min(256, Math.ceil(size / 8) * 64));
    list.push(`https://cryptoicons.org/api/icon/${lower}/${pngSize}`);
    return list;
  }, [normalized, lower, size]);

  const [index, setIndex] = useState(0);
  const [failed, setFailed] = useState(false);

  const onError = () => {
    const next = index + 1;
    if (next < sources.length) {
      setIndex(next);
    } else {
      setFailed(true);
    }
  };

  // For obvious fiat cases, show typographic symbol instead of network calls
  if (normalized === 'USD' || normalized === 'USDT' || normalized === 'USDC') {
    return (
      <span className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size, fontWeight: 600, ...style }}>
        $
      </span>
    );
  }
  if (normalized === 'KRW') {
    return (
      <span className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size, fontWeight: 600, ...style }}>
        ₩
      </span>
    );
  }

  if (failed) {
    return (
      <span className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', color: '#fff', fontSize: Math.max(10, Math.floor(size * 0.45)), fontWeight: 700, ...style }}>
        {normalized}
      </span>
    );
  }

  return (
    <img
      src={sources[index]}
      alt={normalized}
      width={size}
      height={size}
      className={className}
      style={{ display: 'inline-block', width: size, height: size, objectFit: 'contain', ...style }}
      onError={onError}
      loading="lazy"
    />
  );
};

export default TokenIcon;


